module.exports = "../../static/img/exclamation.1746616.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/exclamation.png
// module id = 192
// module chunks = 2